module.exports = __webpack_public_path__ + "src/images/measurements/highHipCircumference.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/highHipCircumference.jpg
// module id = 1148
// module chunks = 0